// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".challenge-icon{padding:8px;background:#222;border-radius:100px;width:22px;height:22px;display:flex;align-items:center;justify-content:center}.challenge-icon i{font-size:12px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
